import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import { Translate } from "orion-components/i18n";
import CloseIcon from '@mui/icons-material/Close';

const stopPropagation = (e) => {
    e.stopPropagation();
};

const ConfirmationModal = ({ open, handleSave, handleClose, openDiscardDialog }) => {

    const styles = {
        title: { color: "#fff", letterSpacing: "unset", lineHeight: "unset" },
        confirm: { background: "#4db5f4", borderRadius: "5px", color: "#fff", padding: "10px 20px" },
        abort: { borderRadius: "5px", color: "#d3615c", padding: "10px 20px" },
        paperPropStyles: {
            backgroundColor: "#212327",
            padding: "15px",
            alignItems: "center",
            width: "520px"
        }
    };

    return (
        <Dialog
            PaperProps={{
                sx: styles.paperPropStyles
            }}
            open={open}
            disableEnforceFocus={true}
            scroll="paper"
            onMouseDown={stopPropagation}
            onTouchStart={stopPropagation}
        >
            <div style={{ display: "flex", flexDirection: "row-reverse", width: "100%" }}>
                <CloseIcon size={20} style={{ color: "#fff", cursor: "pointer" }} onClick={() => handleClose()} />
            </div>
            <DialogTitle sx={styles.title} disableTypography={true}>
                <h3>
                    <Translate value={"modals.confirmationModal.title"} />
                </h3>
            </DialogTitle>
            <DialogContent>
                <DialogContentText variant="body2" color="#fff">
                    <p style={{ color: "#fff", opacity: 0.7 }}>
                        <Translate value={"modals.confirmationModal.desc"} />
                    </p>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => openDiscardDialog()}
                    onMouseDown={stopPropagation}
                    onTouchStart={stopPropagation}
                    sx={styles.abort}
                >
                    <Translate value={"modals.confirmationModal.discard"} />
                </Button>

                <Button
                    x-asc-atf-id="changes-save-confirm-btn"
                    onClick={() => handleSave()}
                    onMouseDown={stopPropagation}
                    onTouchStart={stopPropagation}
                    sx={styles.confirm}
                >
                    <Translate value={"modals.confirmationModal.confirm"} />
                </Button>
            </DialogActions>
        </Dialog >
    )
};

export default ConfirmationModal;